import './style.css';

const Logo = () => {
  return (
    <div className="logo">designbymobius</div>
  )
}

export default Logo